import { render, staticRenderFns } from "./MicroHeader.vue?vue&type=template&id=74bc47de&scoped=true"
import script from "./MicroHeader.vue?vue&type=script&lang=ts"
export * from "./MicroHeader.vue?vue&type=script&lang=ts"
import style0 from "./MicroHeader.vue?vue&type=style&index=0&id=74bc47de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc47de",
  null
  
)

export default component.exports